import type { ITabItem } from 'components/Form';
import { TabsIds } from 'pages/Project/Common/types';

import type React from 'react';
import { useMemo, useCallback } from 'react';

interface IUseErrorTooltipsVisibility {
    activeTab: ITabItem<TabsIds>;
    formRef: React.RefObject<HTMLFormElement | HTMLDivElement>;
}

const hiddenTooltipKey = 'hidden-tooltip';
const selectedTabTooltipKey = 'selected-tab-tooltip';

export const useErrorTooltipsVisibility = (props: IUseErrorTooltipsVisibility) => {
    const { activeTab, formRef } = props;

    const classNameTooltips = useMemo(
        () => ({
            [TabsIds.COMMON]: activeTab?.id !== TabsIds.COMMON ? hiddenTooltipKey : selectedTabTooltipKey,
            [TabsIds.PRICE]: activeTab?.id !== TabsIds.PRICE ? hiddenTooltipKey : selectedTabTooltipKey,
            [TabsIds.ACCUMULATION_SHEET]: undefined,
        }),
        [activeTab?.id],
    );

    const onTooltipAttributeChange = useCallback(
        (_attributeName: string, target: Node) => {
            const { classList } = target as HTMLDivElement;
            const targetTop = parseInt((target as HTMLDivElement).style.getPropertyValue('--popover-top'), 10);
            const { top = 0, height = 0 } =
                formRef?.current
                    ?.getElementsByClassName('viewport-container')?.[0]
                    ?.parentElement?.getBoundingClientRect() || {};

            if (!classList.contains(selectedTabTooltipKey) || !Number.isFinite(targetTop) || !height) {
                return;
            }

            if (targetTop < top || targetTop > top + height) {
                if (!classList.contains(hiddenTooltipKey)) {
                    classList.add(hiddenTooltipKey);
                }
            } else if (classList.contains(hiddenTooltipKey)) {
                classList.remove(hiddenTooltipKey);
            }
        },
        [formRef],
    );

    return {
        classNameTooltips,
        onTooltipAttributeChange,
    };
};
